export enum LocalStorageEnums {
    User_Name = 'User_Name',
    Email = 'Email',
    ID_Number = 'ID_Number',
    Patient_Code = 'Patient_Code',
    sessionDuration = 'sessionDuration',
    SessionExpireDate = 'SessionExpireDate',
    Patient_Mobile = 'Patient_Mobile',
    Patient_Age_Year = 'Patient_Age_Year',
    Patient_Name_Ar = 'Patient_Name_Ar',
    Country = 'Country',
    Imagepath = 'Imagepath',
    OutgoingMailDraft = 'OutgoingMailDraft',
    NitcotekArcdoxLanguage = 'NitcotekArcdoxLanguage',
    User = 'User',
    Token='Token',
    IncomingMailDraft='IncomingMailDraft'
}
export enum EntityTypeEnum {
  DOCUMENTS = 1,
  USERS = 2,
  WORKFLOW = 3,
  INBOX = 4,
  OUTBOX = 5
}
export enum PermissionKeysEnum {
  DOCUMENTS = 'documents',
  USERS = 'users',
  WORKFLOW = 'workflow',
  INBOX = 'inbox',
  OUTBOX = 'outbox'
}
export enum SecrecyLevel {
  NORMAL = 1,
  CONFIDENTIAL = 2,
  TOP_SECRET = 3,
  OFFICIAL_ONLY = 4
}
export enum ApprovalPriority
{
    Normal = 1,
    Urgent24H = 2,
    Immediate1H = 3
}
export enum Priority {
  NORMAL = 1,
  HIGH = 2,
  URGENT = 3,
  LOW = 4
}
export enum ReceiptMethod {
  OFFICIAL_MAIL = 1,
  FAX = 2,
  EMAIL = 3,
  HAND_DELIVERY = 4,
  EXTERNAL_SYSTEM = 5
}
export enum AccessLevel {
  DEPARTMENT_ONLY = 1,
  ALL_MANAGERS = 2,
  ALL_EMPLOYEES = 3,
  MINISTER_ONLY = 4
}
export enum TransactionType {
  Incoming = 1,
  Outgoing = 2,
  Internal = 3
}